/*
 * Copyright (c) "Neo4j"
 * Neo4j Sweden AB [http://neo4j.com]
 *
 * This file is part of Neo4j.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
export const SSO_REDIRECT = 'sso_redirect';
export const REDIRECT_URI = 'redirect_uri';
export const BEARER = 'bearer';
export const PKCE = 'pkce';
export const IMPLICIT = 'implicit';
export const AUTH_LOGGING_PREFIX = 'OIDC/OAuth#';
const AUTH_STORAGE_PREFIX = '/auth#';
export const AUTH_STORAGE_STATE = `${AUTH_STORAGE_PREFIX}state`;
export const AUTH_STORAGE_CODE_VERIFIER = `${AUTH_STORAGE_PREFIX}code_verifier`;
export const AUTH_STORAGE_URL_SEARCH_PARAMS = `${AUTH_STORAGE_PREFIX}url_search_params`;
export const AUTH_STORAGE_LOGS = `${AUTH_STORAGE_PREFIX}logs`;
export const AUTH_STORAGE_REFRESH_DATA = `${AUTH_STORAGE_PREFIX}refresh_data`;
